import { call, put, takeEvery } from 'redux-saga/effects';
import callApi from 'utils/callApi';
import { fetchAccountInformationSuccess } from 'redux/modules/account';
import { fetchAppInfoSuccess } from 'redux/modules/appInfo';

// Actions
export const CREATE_PATIENT_CREDIT_CARD = 'CREATE_PATIENT_CREDIT_CARD';
export const CREATE_PATIENT_CREDIT_CARD_SUCCESS = 'CREATE_PATIENT_CREDIT_CARD_SUCCESS';
export const CREATE_PATIENT_CREDIT_CARD_FAIL = 'CREATE_PATIENT_CREDIT_CARD_FAIL';
export const UPDATE_PATIENT_CREDIT_CARD = 'UPDATE_PATIENT_CREDIT_CARD';
export const UPDATE_PATIENT_CREDIT_CARD_SUCCESS = 'UPDATE_PATIENT_CREDIT_CARD_SUCCESS';
export const UPDATE_PATIENT_CREDIT_CARD_FAIL = 'UPDATE_PATIENT_CREDIT_CARD_FAIL';
export const DELETE_PATIENT_CREDIT_CARD = 'DELETE_PATIENT_CREDIT_CARD';
export const DELETE_PATIENT_CREDIT_CARD_SUCCESS = 'DELETE_PATIENT_CREDIT_CARD_SUCCESS';
export const DELETE_PATIENT_CREDIT_CARD_FAIL = 'DELETE_PATIENT_CREDIT_CARD_FAIL';

// Reducer
export default function patientsCreditCardsReducer(state = {
  data: [], count: 0, loading: 0,
}, action) {
  const { type, payload } = action;
  switch (type) {
    case CREATE_PATIENT_CREDIT_CARD_SUCCESS:
    case UPDATE_PATIENT_CREDIT_CARD_SUCCESS:
    case DELETE_PATIENT_CREDIT_CARD_SUCCESS: {
      const newData = state.data.map((dataItem) => {
        if (dataItem['Record Number'] !== payload['Record Number']) {
          return dataItem;
        }

        return {
          ...dataItem,
          'Credit Card': payload['Credit Card'],
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    default:
      return state;
  }
}

// Action Creators
export function createPatientCreditCard(payload) {
  return { type: CREATE_PATIENT_CREDIT_CARD, payload };
}

export function createPatientCreditCardSuccess(payload) {
  return { type: CREATE_PATIENT_CREDIT_CARD_SUCCESS, payload };
}

export function createPatientCreditCardFail(payload) {
  return { type: CREATE_PATIENT_CREDIT_CARD_FAIL, payload };
}

export function updatePatientCreditCard(payload) {
  return { type: UPDATE_PATIENT_CREDIT_CARD, payload };
}

export function updatePatientCreditCardSuccess(payload) {
  return { type: UPDATE_PATIENT_CREDIT_CARD_SUCCESS, payload };
}

export function updatePatientCreditCardFail(payload) {
  return { type: UPDATE_PATIENT_CREDIT_CARD_FAIL, payload };
}

export function deletePatientCreditCard(payload) {
  return { type: DELETE_PATIENT_CREDIT_CARD, payload };
}

export function deletePatientCreditCardSuccess(payload) {
  return { type: DELETE_PATIENT_CREDIT_CARD_SUCCESS, payload };
}

export function deletePatientCreditCardFail(payload) {
  return { type: DELETE_PATIENT_CREDIT_CARD_FAIL, payload };
}

// Requests
export function requestCreatePatientCreditCard(payload) {
  return callApi('patient/credit_card/', 'POST', payload);
}

export function requestUpdatePatientCreditCard(payload) {
  return callApi('patient/credit_card/', 'PATCH', payload);
}

export function requestDeletePatientCreditCard(payload) {
  return callApi(`patient/credit_card/?id=${payload}`, 'DELETE');
}

export function requestFetchPatientCreditCards(id) {
  return callApi('patient/credit_card/search/', 'POST', {
    filters: [
      {
        name: 'Patient ID',
        operation: 'eq',
        val: id.toString(),
      },
    ],
  });
}

// Sagas
function* createPatientCreditCardSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestCreatePatientCreditCard, values);
    const creditCards = yield call(requestFetchPatientCreditCards, values['User Record Number']);
    yield put(createPatientCreditCardSuccess({
      'Record Number': values['User Record Number'],
      'Credit Card': creditCards.data,
    }));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(createPatientCreditCardFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* updatePatientCreditCardSaga(action) {
  const {
    values: {
      'User Record Number': userRecordNumber,
      ...otherValues
    },
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestUpdatePatientCreditCard, otherValues);
    const creditCards = yield call(requestFetchPatientCreditCards, userRecordNumber);
    yield put(updatePatientCreditCardSuccess({
      'Record Number': userRecordNumber,
      'Credit Card': creditCards.data,
    }));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(updatePatientCreditCardFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* deletePatientCreditCardSaga(action) {
  try {
    const res = yield call(requestDeletePatientCreditCard, action.payload.ID);
    const creditCards = yield call(requestFetchPatientCreditCards, action.payload['Record Number']);
    yield put(deletePatientCreditCardSuccess({
      'Record Number': action.payload['Record Number'],
      'Credit Card': creditCards.data,
    }));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
  } catch (err) {
    yield put(deletePatientCreditCardFail(err.data));
  }
}

export function* patientsCreditCardsSaga() {
  yield takeEvery(CREATE_PATIENT_CREDIT_CARD, createPatientCreditCardSaga);
  yield takeEvery(UPDATE_PATIENT_CREDIT_CARD, updatePatientCreditCardSaga);
  yield takeEvery(DELETE_PATIENT_CREDIT_CARD, deletePatientCreditCardSaga);
}



// WEBPACK FOOTER //
// ./src/redux/modules/patientsCreditCards.js